import { PhoneNumberDto } from '../../autogen/bff-api'

export const displayPhoneNumber = (phoneNumber: PhoneNumberDto): string => {
    return `+${phoneNumber.callingCode.value} ${phoneNumber.number}`
}
